import React from "react";
import * as styles from "./chip-filter-divider.module.scss";

export default function ChipFilterDivider() {
	return <div className={styles.divider} />;
}
